import React from "react";
import dayjs from "../../../../utils/dayjs";
import { getSubjectTheme, formatScheduleEventHint } from "../subjectThemeUtils";

const MonthView = ({ events, currentDate, onEventClick }) => {
  const startOfMonth = currentDate.startOf("month");
  const endOfMonth = currentDate.endOf("month");

  // Tính toán số ngày cần hiển thị (bao gồm cả các ngày của tháng trước/sau để lấp đầy lưới)
  const startDay = startOfMonth.startOf("isoWeek");
  const endDay = endOfMonth.endOf("isoWeek");

  const calendarGrid = [];
  let day = startDay;

  while (day.isBefore(endDay)) {
    calendarGrid.push(day);
    day = day.add(1, "day");
  }

  const daysOfWeek = ["Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7", "Chủ Nhật"];

  return (
    <div className="flex flex-col h-full bg-white">
      {/* Tên các thứ */}
      <div className="grid grid-cols-7 border-b border-gray-100 bg-gray-50/50">
        {daysOfWeek.map((d) => (
          <div key={d} className="py-3 text-center text-[11px] font-black text-gray-400 uppercase tracking-widest">
            {d}
          </div>
        ))}
      </div>

      {/* Lưới ngày */}
      <div className="grid grid-cols-7 grid-rows-5 flex-grow min-h-[600px]">
        {calendarGrid.map((date, idx) => {
          const isCurrentMonth = date.isSame(currentDate, "month");
          const isToday = date.isSame(dayjs(), "day");
          
          // Lọc sự kiện cho ngày này (Trong mockData dùng index 1-7, cần chuyển đổi logic tí)
          // Ở đây giả định bạn sẽ map date.day() khớp với ev.day của mockData
          const dayEvents = events.filter(ev => ev.day === (date.day() === 0 ? 7 : date.day()));

          return (
            <div
              key={idx}
              className={`min-h-[120px] border-r border-b border-gray-50 p-2 transition-colors hover:bg-slate-50/50 ${
                !isCurrentMonth ? "bg-gray-50/30 opacity-40" : ""
              }`}
            >
              <div className="flex justify-between items-center mb-2">
                <span className={`text-xs font-bold w-7 h-7 flex items-center justify-center rounded-full ${
                  isToday ? "bg-red-700 text-white shadow-md shadow-red-200" : "text-gray-400"
                }`}>
                  {date.format("D")}
                </span>
                {dayEvents.length > 0 && isCurrentMonth && (
                  <span className="text-[10px] font-bold text-red-600 bg-red-50 px-1.5 py-0.5 rounded-md">
                    {dayEvents.length} lớp
                  </span>
                )}
              </div>

              {/* Danh sách các lớp (Tối đa hiển thị 3 lớp, còn lại ghi +x) */}
              <div className="space-y-1">
                {isCurrentMonth && dayEvents.slice(0, 3).map((ev) => {
                  const theme = getSubjectTheme(ev);
                  return (
                    <div
                      key={ev.id}
                      onClick={() => onEventClick(ev, date)}
                      title={formatScheduleEventHint(ev)}
                      className={`px-2 py-1 rounded-lg text-[10px] font-bold truncate cursor-pointer border shadow-sm transition-transform active:scale-95 ${theme.bg} ${theme.border} ${theme.text}`}
                      style={{ borderLeftWidth: 3, borderLeftStyle: "solid", borderLeftColor: theme.accent }}
                    >
                      <div className="flex items-center justify-between gap-2">
                        <span className="truncate font-extrabold">
                          {ev.start}h: {ev.class}
                        </span>
                        <span
                          className={`shrink-0 text-[8px] font-black uppercase px-1 py-0.5 rounded border ${
                            ev.venue === "school"
                              ? "border-amber-200 text-amber-800 bg-amber-50/80"
                              : "border-slate-200 text-slate-600 bg-slate-50/80"
                          }`}
                          title={ev.venue === "school" ? "Tại trường" : "Trung tâm"}
                        >
                          {ev.venue === "school" ? "Tr" : "TT"}
                        </span>
                      </div>
                      {ev.subject ? (
                        <div className="mt-1">
                          <span
                            className={`inline-flex max-w-full px-2 py-0.5 rounded-md border text-[9px] font-extrabold ${theme.border} ${theme.text} bg-white/30 truncate`}
                            title={ev.subject}
                          >
                            {ev.subject}
                          </span>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
                {isCurrentMonth && dayEvents.length > 3 && (
                  <p className="text-[10px] text-gray-400 font-bold pl-1">
                    + {dayEvents.length - 3} lớp khác...
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MonthView;